// extracted by mini-css-extract-plugin
export var container = "_bf-0";
export var outlet = "_bf-1";
export var outletEnter = "_bf-2";
export var outletEnterActive = "_bf-3";
export var outletExit = "_bf-4";
export var outletExitActive = "_bf-5";